import { render, staticRenderFns } from "./EspecieCard.vue?vue&type=template&id=0a5fc48d&"
import script from "./EspecieCard.vue?vue&type=script&lang=js&"
export * from "./EspecieCard.vue?vue&type=script&lang=js&"
import style0 from "./EspecieCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports